import { memo, useMemo } from 'react';
import CodeMirror from '@uiw/react-codemirror';
import { html } from '@codemirror/lang-html';
import type { HtmlCodeEditorProps } from './HtmlCodeEditor.types';

/**
 * Syntax-highlighted HTML editor shared by the email widget's code view and the email-template
 * editor, so both surfaces highlight and gutter identically.
 *
 * Deliberately state-free: it renders exactly the `value` it is given. The widget's debounce and
 * artifact-save semantics stay in its own `CodeView`, which is where the widget stores live.
 */
export const HtmlCodeEditor = memo(
  ({ value, onChange, placeholder, readOnly, className }: HtmlCodeEditorProps) => {
    const extensions = useMemo(() => [html()], []);

    return (
      <CodeMirror
        value={value}
        onChange={onChange}
        theme="light"
        extensions={extensions}
        placeholder={placeholder}
        readOnly={readOnly}
        height="100%"
        className={className}
        style={{ height: '100%' }}
      />
    );
  },
);

HtmlCodeEditor.displayName = 'HtmlCodeEditor';
